import { configureStore, Reducer } from '@reduxjs/toolkit';

import { IApplicationContext } from 'shared/types/applicationContext';
import { TProjectsListState, TProjectEditorState } from '../../reducers';

type TApplicationState = TProjectsListState | TProjectEditorState;

/**
 * Хелпер для создания Redux стора
 * @param context IApplicationContext - контекст приложения
 * @param preloadedState IPreloadedState - предзагруженное состояние
 * @param debugEnabled boolean - флаг доступности Redux Devtools на деве
 */
export function createReduxStore(
  context: IApplicationContext,
  reducer: Reducer<TApplicationState>,
  preloadedState: Partial<TApplicationState>,
  debugEnabled: boolean,
) {
  const projectName = context.config.getStrict<string>('projectName');

  return configureStore({
    devTools: debugEnabled ? { name: projectName } : false,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      }),
    preloadedState,
    reducer,
  });
}
